__turbopack_context__.v({
  "body": "EditProfileForm-module-scss-module__Uscj-a__body",
  "column": "EditProfileForm-module-scss-module__Uscj-a__column",
  "description": "EditProfileForm-module-scss-module__Uscj-a__description",
  "infoBlock": "EditProfileForm-module-scss-module__Uscj-a__infoBlock",
  "infoText": "EditProfileForm-module-scss-module__Uscj-a__infoText",
  "inputsLabel": "EditProfileForm-module-scss-module__Uscj-a__inputsLabel",
  "inputsWrapper": "EditProfileForm-module-scss-module__Uscj-a__inputsWrapper",
  "link": "EditProfileForm-module-scss-module__Uscj-a__link",
  "optImg": "EditProfileForm-module-scss-module__Uscj-a__optImg",
  "optionContent": "EditProfileForm-module-scss-module__Uscj-a__optionContent",
  "row": "EditProfileForm-module-scss-module__Uscj-a__row",
  "secondaryLabel": "EditProfileForm-module-scss-module__Uscj-a__secondaryLabel",
  "teamOption": "EditProfileForm-module-scss-module__Uscj-a__teamOption",
});
